<template>
  <div class="login-container">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center m-b-md">
          <h3>PASSWORD RESET</h3>
          <small>Please fill the form to reset your password</small>
        </div>
        <div class="hpanel">
          <div class="panel-body">
            <p>
              Enter your email address and your password will be reset and emailed to you.
            </p>
            <form v-on:submit="resetPassword" action="#" method="post" id="resetPassword">
              <div class="form-group">
                <label class="control-label" for="password">New Password</label>
                <input type="password" title="Please enter you new password" required v-model="password" value="" name="password" id="password" class="form-control">
                <span class="help-block small">Your new secure password</span>
              </div>

              <div class="form-group">
                <label class="control-label" for="passwordConfirm">Confirm New Password</label>
                <input type="password" title="Please enter you password confirmation" required v-model="passwordConfirm" value="" name="passwordConfirm" id="passwordConfirm" class="form-control">
                <span class="help-block small">Password confirmation</span>
              </div>

              <div v-if="errorResetPassword === false" class="alert alert-success" style="margin: 10px 0">
                <p>
                  your password has been changed, you will be redirected to the login page.
                </p>
              </div>

              <div v-else-if="errorResetPassword !== null" class="alert alert-danger" style="margin: 10px 0">
                {{errorResetPassword}}
              </div>

              <vue-ladda type="submit" :loading="submitReset.loading" class="btn btn-info btn-block" :data-style="submitReset.dataStyle">Reset password</vue-ladda>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright Idexlab
      </div>
    </div>
  </div>

</template>

<script>

import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  name: 'ResetPassword',
  methods: {
    resetPassword: function (event) {
      if (this.token != null) {
        this.submitReset.loading = true
        this.axios.patch('/auth/resetPassword', {
          token: this.token,
          password: this.password,
          password_confirmation: this.passwordConfirm
        })
          .then((response) => {
            this.errorResetPassword = false

            setTimeout(() => {
              this.$router.push({name: 'Login'})
              this.submitReset.loading = false
            }, 5000)
          })
          .catch((error) => {
            if (error.response.status === 400) {
              switch (error.response.data.code) {
                case 1:
                  this.errorResetPassword = error.response.data.errors['token'][0]
                  break
                case 2:
                  this.errorResetPassword = error.response.data.errors['password'][0]
                  break
              }
            }
            this.submitReset.loading = false
          })
      }
      event.preventDefault()
    }
  },
  mounted () {
    this.token = this.$route.params.token

    if (typeof this.token === 'undefined') {
      this.errorResetPassword = 'Your token is not valid'
    }
  },
  data () {
    return {
      password: '',
      passwordConfirm: '',
      errorResetPassword: null,
      token: null,
      submitReset: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      year: new Date().getFullYear()
    }
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/ResetPassword.vue